// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review[data-v-41e00892]{background:#fff;box-sizing:border-box;height:100vh;overflow:auto;padding:14px 0 0;position:fixed;top:0;width:100%;z-index:51;&.reviewLinks[data-v-41e00892]{z-index:51}}.review__title[data-v-41e00892]{color:#010d35;font-size:20px;font-weight:600;line-height:25px;margin-bottom:15px;text-align:center}.review__btn[data-v-41e00892]{margin-bottom:210px;padding:0 16px}.Novikov .review__title[data-v-41e00892]{color:#0a0a0a}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
